import CryptoJS from 'crypto-js';
export function getKeyHash(secretkey) {
    let res = '';
    res = String(CryptoJS.SHA3(secretkey, { outputLength: 256 }));
    return res;
}
